export default {
  'Рекомендации': 'recommendations',
  title: {
    segments: 'Segmente',
    attributes: 'Atribution'
  },
  color_switcher: {
    dark: 'Dunkel',
    light: 'Hell'
  },
  routes: {
    product_recommendations: 'Produkt Empfehlungen',
    recommendations: 'Empfehlungen',
    bisness_rules: 'Algorythmen',
    new_business_rules: '',
    instruments: 'Instrumente',
    pipeline: 'Szenarien',
    pipeline_hint: 'Szenario-Editor: Ketten aus E-Mails, Push und Bedingungen.',
    authorization: 'Anmeldung',
    desktop: 'Desktop',
    personal_area: 'Account',
    multilead: '',
    lead: 'Leadkarte',
    leads: 'Leads',
    allleads: 'Alle Leads',
    statistic: 'Statistik',
    visits: 'Besuche',
    visit: 'Besuch',
    cart: 'Warenkörbe',
    letters: 'E-Mails',
    forms: 'Formen',
    segments: 'Segmente',
    editing: 'Bearbeiten',
    assortment: 'Sortiment',
    allemails: 'Alle E-Mails',
    autocast: 'Trigger E-Mail',
    editing_autocast: 'Trigger E-Mails bearbeiten',
    create_autocast: 'Trigger E-Mail erstellen',
    emails: 'Newsletter',
    create_email: 'Newsletter erstellen',
    auto_emails: 'Trigger E-Mails',
    widgets: 'Widgets',
    emails_templates: 'E-Mail Vorlagen',
    emails_template: 'E-Mail Vorlagen',
    promotional_codes: 'Gutscheine',
    reports: 'Berichte',
    all_orders: 'Alle Bestellungen',
    customer_orders: 'Kunden Bestellungen',
    analytics: 'Analytik',
    analytics_leads: 'Kundenanalytik',
    analytics_visits: 'Besuchsanalytik',
    analytics_emails: 'Newsletter Analytik',
    analytics_widgets: 'Widget-Analyitk',
    analytics_recommendations: 'Empfehlungs-Analytik',
    analytics_emails_dynamics: 'Analytik zu E-Mail Dynamik',
    analytics_autocasts: 'Trigger E-Mail Analytik',
    analytics_sales_funnel: 'Sales Funnel Analytik',
    analytics_sales: 'Verkaufsanalytik',
    analytics_offers: 'Produktanalytik',
    analytics_rfm: 'RFM-Analyse',
    offers: 'Produkte',
    kpi_store: 'Geschäfts KPI',
    average_check: 'Average check',
    paid_offers_rate: 'Ausführung von Bestellung',
    purchase_rate: 'Kaufhäufigkeit',
    returned_customers: 'Prozent der Stammkunden',
    library: 'Bibliothek',
    image: 'Bilder',
    integration: 'Integration',
    settings: 'Einstellungen',
    settings_account: 'Account Einstellungen',
    change_password: 'Passwort verändern',
    settings_alerts: 'Benachrichtigungen',
    sites_list: 'Webseiten Liste',
    users: 'Benutzer',
    tool_management: 'Instrumente verwalten',
    timeline: 'Timeline',
    efficiency_leadhit: 'Effektivität von LeadHit',
    site_forms: 'Formen der Webseite'
  },
  side_menu: {
    by_visits: 'Besuche',
    by_leads: 'Leads',
    by_emails: 'Newsletter',
    by_widgets: 'Widgets',
    by_recommendations: 'Empfehlungen',
    by_emails_dynamic: 'E-Mail Dynamik',
    by_autocasts: 'Triggered E-Mails',
    by_sales_funnel: 'Sales Funnel',
    by_sales: 'Verkauf',
    app_language: 'Systemsprachen',
    app_languages: 'Systemsprachen',
    your_profile: 'Ihr Profiel',
    profile_settings: 'Profieleinstellungen',
    my_sites: 'Webseiten',
    my_users: 'Nutzer',
    by_efficiency_leadhit: 'LeadHit Effiktivität',
    by_offers: 'Produkte',
    rfm_analysis: 'RFM-Analyse'
  },
  mini_dashbord: {
    instruments_widgets: 'Hier finden Sie alle Ergebnisse der Arbeit von den LeadHit Wingets',
    instruments_message_campaings: 'Hier finden Sie die Effektivitätsberichte über Ihre Newsletter',
    instruments_autocast:
      'Verfolgen Sie die  veränderungen der Effektivität von Ihren Trigger E-Mails',
    leads_leads: 'Bekommen Sie alle Analytik über Ihre Leads für eine ausgewählte Zeitspanne',
    leads_segments:
      'Benutzer können Gruppiert werden um ihnen präzisere Produkt Empfehlungen zu zeigen',
    instruments_recommendations: 'Alle aktive oder unaktive Produkt Empfehlungen',
    instruments_bisness_rules: 'Liste der Algorythmen die für die Produkte Ihrer Webseite',
    instruments_user_alerts:
      'Hier ist die vollständige Liste den von Ihnen eingerichteten Benachrichtigngen gesammelt',
    library_image:
      'Alle von Ihnen hochgeladene Bilder. Können für die Arbeit mit den  Instrumente benutzt werden',
    library_emails_templates: 'Vollständige Liste von Ihren E-Mail Vortlagen',
    library_promocodes: 'Vollständige Liste und Statistik Ihrer Gutschein-Codes',
    reports_all_orders: 'Komplette Analytik über Bestellung für defenierbare Zeitspannen',
    reports_recomendations:
      'Hier finden Sie die Berichte über die Arbeit und Effektivität von den Produkt Empfehlungen',
    reports_message_campaings: 'Analytik über die Effektivität aller Trigger E-Mails',
    reports_autocast: 'Analytik über die Effektivität aller Newsletter',
    efficiency_leadhit: 'Hier finden Sie die Berichte über die Effektivität von LeadHit',
    reports_sources_of_orders: 'Analysieren Sie, was die Effektivsten Auftragsquellen sind',
    instruments_loyalty_categories:
      'Loyalitäts Kategorien, die in der Arbeit von LeadHit benutzt werden',
    instruments_loyalty_rules: 'Algorythmen zu bestimmung der Loyalitäts Kategorie'
  },
  confirm_leave_route: '',
  receive: 'Erstellen',
  racoon_header_text: 'Willkommen im persönlichen Bereich LeadHit',
  equals: 'Gleich',
  does_not_equal: 'Nicht gleich',
  russian: 'Russisch',
  english: 'Englisch',
  deutsch: 'Deutsch',
  back: 'Zurück',
  yes: 'Ja',
  no: 'Nein',
  offer_title: 'Name',
  error_request_data: 'Fehler bei der Datenabfrage',
  error: 'Fehler',
  lead: 'Lead',
  sign_in: 'Anmelden',
  registration: 'Registrieren',
  sign_up: 'Registrieren',
  enter_login: 'Login eingeben',
  enter_password: 'Passwort',
  enter_email: 'E-Mail',
  enter_phone: 'Telefon eingeben',
  confirm_processing_user_data:
    'Ich bestätige die Datenschutzerklärung gelesen zu habe und stimme ihr zu',
  registration_password_error: 'Das Passwort muss mindestens 8 Zeichen lang sein',
  you_can_check_mail: 'Überprüfen Sie Ihre E-Mails',
  we_sent_information_to_mail: 'Eine Email ist auf dem Weg',
  i_forgot_password: 'Passwort vergessen',
  success_registration_confirm_message: 'Der Nutzer wurde eingetragen',
  enter_new_password: 'Geben Sie ein neues Passwort ein',
  password_success_updated: 'Das Passwort wurde erneuert',
  marketing_automation_service: 'Marketing Automatisierung',
  data_out_of_date: 'Die Angaben sind veraltet',
  repeat_confirm_registration_description:
    'Geben Sie Ihre E-Mail an, damitt wir die Email an Sie schicken können',
  name: 'Name',
  surname: 'Nachname',
  company: 'Gesellschaft',
  position: 'Berufsbezeichnung',
  save: 'Speichern',
  cancel: 'Zurück',
  add: 'Hinzufügen',
  tool_setup: 'Instrumente einstellen',
  no_data: 'Keine Daten vorhanden',
  apply: 'Anwenden',
  create: 'Erstellen',
  reset: 'Zurücksetzen',
  show: 'Angezeigt',
  hide: 'Ausblenden',
  send: 'Absenden',
  choice: 'Wahl',
  choose_a_period: 'Zeitspanne',
  delete_selected: 'Die Markierten löschen',
  import: 'Importioren',
  more_details: 'Details',
  total: 'Insgesammt',
  used: 'Benutzt',
  alerts: 'Benachrichtigungen',
  remained: 'Übrig',
  start_typing: 'Eingabe beginnen',
  uploaded: 'Hochgeladen',
  download: 'Anschließen',
  generate: 'Generieren',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  select_from_list: 'Aus der Liste wählen',
  from_list: 'Aus der Liste',
  select_all: 'Alle auswählen',
  password: 'Passwort',
  phone: 'Telefon',
  timed_out: 'Zeit der Anfrage ist abgelaufen',
  version: 'Version',
  close: 'Schließen',
  align: 'Ausrichten',
  copy: 'Kopieren',
  time: 'Datum',
  hours: '{n} Stunde | {n} Stunden | {n} Stunden',
  minutes: '{n} Minute | {n} Minuten | {n} Minuten',
  pcs: 'St.',
  minute: 'Minuten',
  amount_total: 'Summe',
  select: 'Auswählen',
  date: 'Datum',
  category: 'Kategorie',
  categories: 'Kategorien',
  logout: 'Ausloggen',
  product_introduction: 'Einführung in das Produkt',
  choose_site: 'Seite wählen',
  switch_language: 'Sprache ändern',
  toggle_color_theme: 'Farbthema wechseln',
  no_sites_available: 'Keine verfügbare Websiten',
  segment: 'Segment',
  group: 'Gruppe',
  descending: 'Absteigen',
  ascending: 'Aufsteigend',
  data_successfully_sent_to_email: 'Die Daten wurden als E-Mail geschickt',
  choose_all: 'Alle auswählenn',
  update: 'Erneuern',
  misc: 'Weitere informationen',
  desktop: {
    weekly_sales_funnel: 'Sales Funnel dieser Woche',
    shown: 'Angezeigt werden',
    widgets_are_active: 'Aktive Widgets',
    widgets_count: '{n} Widget | {n} Widget | {n} Widgets',
    orders_per_week: 'Bestellungen dieser Woche',
    visits_per_week: 'Besuchsdaten dieser Woche',
    with_leadhit: 'mit LeadHit',
    earned: 'Verdient',
    earned_with_leadhit: 'Verdient durch LeadHit',
    percentage_of_income_from_using_LeadHit: 'Von LeadHit generierter Einkommensprozent'
  },
  auth: {
    entered_parameters_incorrect: 'Die Daten stimmen nicht',
    everything_is_ready: 'Alles fertig',
    check_inbox_mobile_text_first: 'Alle Information wurde Ihnen',
    check_inbox_mobile_text_second: 'als Email geschickt',
    marketing_automation: 'Marketing-Automatisierung',
    too_many_attempts_try_again_later: 'Zu viele Anfragen, bitte versuchen Sie es später',
    not_a_valid_email_address: ''
  },
  information: 'Information',
  status: 'Status',
  settings: {
    total_offers_count: '',
    unavailable_offers_count: '',
    spf_correct: '',
    spf_not_correct: '',
    the_domain_should_look_like_this: 'Der Domain muss dieses Format haben',
    failed_to_load_feed: 'Der feed konnte nicht geladen werden',
    send_information_to_the_developer: 'Informarion an den Programmierer',
    send_all: 'Alles schicken',
    enter_feed_link: 'Geben Sie den Link zum Feed an',
    tracker_code_connected: 'Zähler Code ist angeschlossen',
    order_code_connected: 'Bestell Code ist angeschlossen',
    tracker_code_not_connected: 'Zähler Code ist nicht angeschlossen',
    order_code_not_connected: 'Bestell Code ist nicht angeschlossen',
    get_order_code: 'Bestellcode erstellen',
    get_tracker_code: 'Zähler Code erstellen',
    order_code: 'Bestell-Code',
    webpush_sw_file: 'Datei für Web-Push-Benachrichtigungen',
    tracker_code: 'Zähler-Code',
    update_offers_via_file_feed: 'Regelmäßig Daten im System mit dem Feed synchronisieren',
    are_you_sure_you_want_to_delete_the_feed: 'Wollen Sie den Feed wirklich löschen?',
    feed_not_added: 'Der Feed ist nicht angeschossen',
    feed_added: 'Feed hinzegefügt',
    write_to_tech_support: 'Support schreiben',
    upload_feed: 'Feed hochladen',
    change_feed: 'Feed verändern',
    delete_feed: 'Feed löschen',
    technical_account_settings: 'Technische Einstellung des Accounts',
    get_weekly_reports: 'Wöchentlich Berichte bekommen',
    new_password: 'Neus Passwort',
    turn_off_all: 'Alle ausschalten',
    turn_on_all: 'Alle anschalten',
    product_alerts: 'Produkt Benachrichtigung',
    invoice_alerts: 'Rechnung Benachrichtigung',
    service_alerts: 'Service Benachrichtigung',
    commercial_alerts: 'Kommerzielle Benachrichtigung',
    add_domain: 'Domain hinzufügen',
    add_site: 'Site hinzufügen',
    enter_domain_URL: 'Domain URL hinzufügen',
    enter_feed_URL: 'Feed URL eingeben',
    site_successfully_created: 'Seite erfolgreich erstellt',
    error_creating_site: 'Fehler bei der Erstellung der Seite',
    activity: 'Aktivität',
    add_user: 'Nutzer hinzufügen',
    login: 'Login',
    mail: 'E-Mail',
    domain: 'Domain',
    domain_name: 'Domainname',
    date_added: 'Hinzufügungsdatum',
    feed: 'Feed',
    feed_name: 'Feed Name',
    edit_domain: 'Domain bearbeiten',
    no_need_update_data: 'Die Daten müssen nicht erneuert werden',
    site_successfully_updated: 'Webseite aktualisiert',
    site_id: 'Webseite ID',
    technical_settings_of_service: 'Technische Einstellungen des Service',
    technical_settings: 'Technische Einstellungen',
    information_sent_to_your_developer: 'Die Information wurde an Ihren Programmierer geschickt',
    link_for_collecting_forms_on_the_site: 'Link, um die Formen zu sammeln',
    block_banner: 'Banner blockieren',
    subscription: 'Subscription',
    cart_form: 'Warenkorb Form',
    final_order_form: 'Letzte Form beim Bestellen',
    block_banner_hint: 'Banner blokieren',
    cart_form_hint: 'Warenkorb Form',
    final_order_form_hint: 'Finale Bestell-Form',
    form_settings: 'Formen einstellen',
    site_categories: 'Produktkategorien',
    site_categories_description: 'Verwaltung von Produktkategorien für "Verlassene Kategorie" E-Mail-Kampagne',
    upload_categories_file: 'Kategorien aus Datei hochladen',
    file_requirements: 'Dateianforderungen: Spaltentrennzeichen - Semikolon. Spaltenüberschriften: name, url, id.',
    select_csv_file: 'CSV-Datei auswählen',
    selected_file: 'Ausgewählte Datei:',
    upload_categories: 'Kategorien hochladen',
    uploading: 'Hochladen...',
    add_category: 'Kategorie hinzufügen',
    category_name: 'Kategoriename:',
    category_name_placeholder: 'Kategoriename eingeben',
    category_url: 'Kategorie-URL:',
    category_url_placeholder: 'https://example.com/category',
    yml_category_id: 'YML-Kategorie-ID:',
    yml_category_id_placeholder: 'YML-ID eingeben',
    adding: 'Hinzufügen...',
    category_settings: 'Kategorieeinstellungen',
    url_params_title: 'Schlüsselparameter in Kategorie-URLs',
    url_params_label: 'Parameter (durch Komma getrennt):',
    url_params_placeholder: 'utm_source, utm_medium, ref',
    save_params: 'Parameter speichern',
    categories_list: 'Kategorieliste',
    refresh: 'Aktualisieren',
    delete_all: 'Alle löschen',
    loading_categories: 'Kategorien werden geladen...',
    no_categories: 'Keine Kategorien gefunden',
    actions: 'Aktionen',
    delete: 'Löschen',
    confirm_delete_category: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?',
    delete_category: 'Kategorie löschen',
    confirm_delete_all_categories: 'Sind Sie sicher, dass Sie alle Kategorien löschen möchten?',
    delete_all_categories: 'Alle Kategorien löschen',
    delete_all_warning: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Kategorien werden dauerhaft gelöscht.',
    category_uploaded: 'Kategorien erfolgreich hochgeladen',
    category_added: 'Kategorie erfolgreich hinzugefügt',
    category_updated: 'Kategorie erfolgreich aktualisiert',
    category_deleted: 'Kategorie erfolgreich gelöscht',
    all_categories_deleted: 'Alle Kategorien erfolgreich gelöscht',
    url_params_saved: 'URL-Parameter gespeichert',
    upload_error: 'Fehler beim Hochladen der Datei',
    add_error: 'Fehler beim Hinzufügen der Kategorie',
    update_error: 'Fehler beim Aktualisieren der Kategorie',
    delete_error: 'Fehler beim Löschen der Kategorie',
    delete_all_error: 'Fehler beim Löschen aller Kategorien',
    save_params_error: 'Fehler beim Speichern der Parameter',
    select_csv_error: 'Bitte wählen Sie eine CSV-Datei aus',
    search_placeholder: 'Nach Kategoriename suchen...',
    delete_selected: 'Ausgewählte löschen',
    delete_selected_categories: 'Ausgewählte Kategorien löschen',
    confirm_delete_selected_categories: 'Sind Sie sicher, dass Sie die ausgewählten Kategorien löschen möchten?',
    selected_categories_deleted: 'Ausgewählte Kategorien erfolgreich gelöscht',
    delete_selected_error: 'Fehler beim Löschen der ausgewählten Kategorien',
    update_form_setting_question: 'Wollen Sie die Form wirklich verändern?',
    form_updated_successfully: 'Die Form wurde verändert',
    form_update_error: 'Fehler bei der Veränderung',
    choose_tariff: 'Tarif wählen',
    users: {
      user_name: 'Benutzername',
      role: 'Rolle',
      sites: 'Webseiten',
      editing: 'Bearbeiten',
      delete: 'Löschen',
      manager: 'Manager',
      guest: 'Besucher',
      title_for_input_username:
        'Es können nur lateinische Buchstaben, Zahlen und Unterstrich benutzt werden',
      invalid_login: 'Falsches Passwort',
      re_enter_password: 'Geben Sie das Passwort erneut ein',
      passwords_do_not_match: 'Die Passwörter stimmen nicht überein',
      invalid_email: 'Falsches Passwort',
      confirm_password: 'Passwort bestätigen',
      email: 'E-Mail- Adresse',
      choose_role: 'Position auswählen',
      choose_site: 'Webseite auswählen',
      you_edited_data: 'Sie haben die Daten bearbeitet',
      delete_user: 'Nutzer löschen',
      add_new_user: 'Nutzer hinzufügen',
      user_data_updated_successfully: 'Die Nutzerdaten wurden erfolgreich erneuert',
      you_sure_want_delete_user: 'Wollen Sie wirklich den Nutzer löschen',
      user_will_be_deleted: 'Zu löschender Nutzer',
      user_successfully_deleted: 'Nutzer Profil wurde gelöscht',
      user_created_successfully: 'Nutzer Profil erstellt',
      no_changes: 'Keine Veränderungen',
      please_select_at_least_one_site: 'Bitte mindestens eine Seite wählen',
      block: 'Bockieren',
      active: 'Aktiv'
    }
  },
  notifications: {
    need_soft_redirect: 'Um die neue Version zu sehen, loggen Sie sich bitte noch ein mal ein',
    notifications_count: '{n} Benachrichtigung  | {n} Benachrichtigungen | {n} Benachrichtigungen',
    you_have: 'Sie haben',
    notifications: 'Benachrichtigungen'
  },
  timeline: {
    visit_start: 'Besuchsanfang',
    visit_end: 'Besuchsende',
    page_visit: 'Seite geöffnet',
    cart_item: 'Produkt hinzugefügt',
    email_clicked: 'Übergang aus der E-Mail',
    email_delivered: 'E-Mail zugestellt',
    email_opened: 'E-Mail geöffnet',
    widget_popup_view: 'Hat ein Widget gesehen',
    widget_fill: 'Widget ausgefüllt',
    widgets_close: 'Widget geschlossen',
    recommendations_clicks: 'Klicks auf empfohlene Produkte',
    webpush_shown: 'Web-Push gesehen',
    webpush_clicked: 'Web-Push angeklickt',
    webpush_closed: 'Web-Push geschlossen',
    webpush_dismissed: 'Web-Push geschlossen',
    form: 'Form ausgefüllt',
    order: 'Bestellt',
    default: 'Undefiniert',
    select_options_to_filter: 'Filterparameter wählen',
    this_field_displays_the_selected_filters: 'Hier werden die gewählten Filter angezeigt',
    total_events: 'Gesamtereignisse',
    pages_visited: 'Gesehene Seiten',
    completed_forms: 'Ausgefüllte Formen',
    received_emails: 'E-Mails bekommen',
    orders_made: 'Ausgeführe Bestellungen',
    there_are_no_events_for_the_selected_period: 'Keine Ereignisse in dem Zeitraum',
    no_options_to_display: 'Keine Parameter für den Filter gewählt'
  },
  all_leads: {
    double_opt_in: '',
    date_of_appearance: 'Erster Besuch',
    list_of_all_leads: 'Liste von allen Leads',
    no_name: 'Kein Name vorhanden',
    lead_import: 'Leads importieren',
    overwrite_existing_lead_values: 'Werte vorhandener Leads überschreiben',
    you_can_upload_csv_file_with_leads: 'Sie können ein CSV Dokument mit Leads hochladen',
    information_about_csv_file_format: 'Information über den CSV Format',
    no_file_selected: 'Kein Dokument gewählt',
    file_size_is_too_large: 'Die Dateigröße ist größer als zulässig',
    number_of_successfully_loaded_leads: 'Zahl der hochgeladenen Leads',
    number_of_overwritten_leads: 'Zahl der überschriebenen Leads',
    number_of_errors: 'Zahl der Fehler',
    import_example: {
      name: 'Karl',
      surename: 'Müller',
      phone: '+49 30 901820',
      country: 'Germany',
      city: 'Berlin',
      address: 'Stralauer Str. 45',
      sex: 'M/F',
      status: 'New/Contact/Lead/Manager/Regular/Wholesale'
    },
    import_rules: {
      semicolon_must_be_used_as_separator: 'Es muss ein Semikolon (;) als Trennzeichen verwenden',
      default_status: 'Wenn Sie kein Leadstatus angeben, wird er als “Neu” markiert',
      required_and_optional_field:
        'Die E-Mail ist das Hauptfeld, die Restlichen müssen nicht ausgefüllt werden',
      table_example: 'Die Überschriften in der Tabelle müssen der Vorlage entsprechen'
    },
    lead: {
      contact_details: 'Kontaktinformationen',
      contact_information: 'Persönliche Information',
      unsubscribe: 'Abmelden',
      unsubscribe_from_autocasts: 'Von Trigger E-Mails abmelden',
      unsubscribe_from_emails: 'Von Newsletter abmelden',
      unsubscribe_from_all_newsletters: 'Von allen E-Mails abmelden',
      all_visits: 'Alle Besuche',
      total_visits: 'Besuche insgesammt',
      visit_status: 'Besuchstatus',
      technical_data: 'Technische Daten',
      postcode: 'Postleitzahl',
      country: 'Land',
      region: 'Region',
      city: 'Stadt',
      device: 'Geräte',
      os: 'System',
      browser: 'Browser',
      viewed_categories: 'Angesehene Kategorien',
      viewed_offers: 'Angesehene Produktseiten',
      number_views: 'Zahl der Ansichten',
      purchased_goods: 'Gekaufte Produkte',
      visit_page: 'Besuchte Seiten',
      add_to_cart: 'Im Warenkorb',
      date_of_completion: 'Fertiggestellt am',
      last_step_of_cart: 'Letzer Schritt der Bestellung',
      fill_URL: 'URL beim Ausfüllen',
      subscription_settings_changed: 'E-Mail Einstellungen verändert',
      subscription_settings_not_changed: 'Abonnementeinstellungen geändert',
      subscription_update_failed: 'Abonnementeinstellungen nicht verändert',
      edit_lead_summary_title: 'Lead Daten verändern',
      edit_lead_summary_question: 'Wollen sie wirklich die veränderten Lead Daten speichern',
      error_lead_summary: 'Fehler beim Speichern',
      lead_summary_success_updated: 'Die Daten wurden gespeichert',
      status: {
        new: 'Neu',
        contact: 'Kontakt',
        customer: 'Käufer',
        manager: 'Manager',
        regular: 'Stammkunde',
        wholesale: 'Großabnehmer'
      }
    }
  },
  segments: {
    segment_created: '',
    segment_updated: '',
    segments_deleted: '',
    segment_deleted: '',
    lead_groups: 'Lead Gruppen',
    all_segments: 'Alle Segmente',
    segment_name: 'Segmentname',
    number_leads: 'Zahl der Leads',
    content: 'Inhalt',
    select_segments: 'Segmente wählen',
    add_segment: 'Segment hinzufügen',
    delete_segments: 'Löschen von Segmenten',
    delete_segments_question: 'Wollen Sie wirklich die folgenden Segmente löschen?',
    male: 'Männlich',
    female: 'Weiblich',
    save_segment: 'Segment speichern',
    appearance_time: 'Erscheinungszeit',
    score: 'Rating',
    completed_form: 'Ausgefüllte Formen',
    sex: 'Geschlecht',
    unsubscribed: 'Abgemeldet',
    loaded: 'Geladen',
    lead_status: 'Lead Status',
    sent_mailing: 'Geschickte E-Mails',
    order_date: 'Bestelldatum',
    last_order_date: 'Datum der letzten Bestellung',
    selected_filters_empty_placeholder: 'Hier werden die gewählten Filter erscheinen',
    enter_segment_name: 'Geben Sie ein Segmentname ein',
    save_segment_text: 'Das Segment wird nach folgenden Parametern erstellt',
    select_at_least_one_condition: 'Es muss mindestens eine Bedingung gewählt sein',
    select_condition: 'Wählen Sie eine Bedingung',
    select_operator: 'Operator wählen',
    define_value: 'Inhalt eingeben',
    no_need_save_data: 'Die Daten müssen nicht gespeichert werden',
    copy_segments: 'Segmente kopieren',
    copy_segments_text: 'Texte der Segmente kopieren',
    export: 'Export',
    export_segments: 'Segmentenexport',
    segments_sent_to_your_email: 'Segment wurde an Ihre E-Mail geschickt',
    number_of_multilead_orders: 'Bestellungen des Mulitleads',
    number_of_multilead_visits: 'Besuche des Mulileads',
    amount_of_multilead_orders: 'Bestellsumme des Multileads',
    date_of_last_site_visit: 'Letzte Besuch des Muktileads',
    multilead_time_added: 'Erscheinungsdatum des Multileads',
    opened_mass_emails_by_last_n_days: 'Massenversand in den letzten N Tagen geöffnet',
    recieved_mass_messages: 'Massenversand erhalten'
  },
  image: {
    no_uploaded_images: 'Sie haben keine hochgeladene Bilder',
    max_image_size: 'Maximale größe eine Bildes',
    acceptable_image_formats: 'Zulässige Formate',
    drag_and_drop_files_to_upload: 'Ziehen Sie die Datei hier rüber um sie hochzuladen',
    select_files: 'Datei wählen',
    image_upload: 'Bilder hochladen',
    all_uploaded_images: 'Alle hochgeladenen Bilder',
    not_valid_image_message: 'Falsches Format oder unzulässige Bildgröße',
    images_successfully_uploaded: 'Bilder erfolgreich hochgeladen',
    upload_error: 'Fehler beim Hochladen der Bilder',
    load_error: 'Fehler beim Laden der Bilder',
    image_successfully_deleted: 'Bild erfolgreich gelöscht',
    delete_error: 'Fehler beim Löschen des Bildes',
    image_successfully_updated: 'Bild erfolgreich aktualisiert',
    update_error: 'Fehler beim Aktualisieren des Bildes',
          url_copied_to_clipboard: 'URL in die Zwischenablage kopiert',
      copy_url_error: 'Fehler beim Kopieren der URL',
      loading_images: 'Bilder werden geladen...'
  },
  integration: {
    api_text_generate:
      'Hier können Sie einen Schlüssel für die Arbeit mit LeadHit durch API generieren. Geben Sie ihn im oberen Teil der POST-Anfrage mit API-KEY an'
  },
  emails_templates: {
    archive_template: '',
    unarchive_template: '',
    archive_template_question: '',
    unarchive_template_question: '',
    emails_template_has_been_archived: '',
    emails_template_has_been_unarchived: '',
    show_archived_template: '',
    name_template: 'Vorlagenname',
    channel: 'Kanal',
    used_in_autocasts: 'Wir in Trigger E-Mails benutzt',
    active: 'Aktiv / Nicht aktiv',
    date_of_creation: 'Erstell-Datum',
    delete_template: 'Vorlage löschen',
    copy_template: '',
    confirm_popup_delete_body_text: 'Wollen Sie die Vorlage wirklich löschen',
    confirm_popup_copy_body_text: '',
    name_selected_template: 'Name der gewählten Vorlage',
    template_deleted: 'Vorlage gelöscht',
    error_deleting_template: 'Fehler beim Löschen',
    preview: 'Vorschau',
    create_new_email_template: 'Vorlage erstellen',
    stripo_editor: 'Stripo Editor',
    code_editor: 'Code Editor',
    webpush_editor: 'Web Push',
    select_template_type_body_text_first: 'Wählen Sie ein Format der E-Mail-Vorlage',
    select_template_type_body_text_second: 'Die Formate sind unkompatibel',
    select_template_type_body_text_third_first: 'Vorlage die in Stripo gespeichert sind, ',
    select_template_type_body_text_third_second: 'können nicht reaktiviert werden',
    enter_template_name: 'Name der Vorlage',
    copy_html: 'HTML kopieren',
    template_saved_successfully: 'Vorlage wurde gespeichert',
    error_save_template: 'Fehler beim speichern',
    code_copied_successfully: 'Code wurde gespeichert',
    hidden_pre_title: 'Verborgene überschrift',
    preheader_description:
      'Verborgener Text, der als Fortsetzung des Themas in einem noch nicht geöffneten E-Mail angezeigt wird',
    copy: 'Kopieren',
    copy_url: 'URL kopieren',
    duplicate: 'Kopie',
    export_email_template:
      'E-Mail Vorlage exportieren | E-Mail Vorlagen exportieren | E-Mail Vorlagen exportieren',
    confirm_popup_export_body_text:
      'Sind Sie sicher, dass sie die Vorlage exportieren wollen | Sind Sie sicher, dass sie die Vorlagen exportieren wollen | Sind Sie sicher, dass sie die Vorlagen exportieren wollen',
    name_of_selected_email_template:
      'Name der E-Mail Vorlage | Name der E-Mail Vorlage | Name der E-Mail Vorlage',
    template_export_error: 'Fehler beim Export der Vorlage',
    templates_export_error: 'Fehler beim Export der Vorlage',
    import: 'Import',
    import_email_templates: 'E-Mail Vorlagen Importieren',
    overwrite_existing_templates: 'Vorhandene Vorlagen überschreiben',
    file_format_should_be_html_or_mjml: 'Das Dateiformat muss html oder mjml sein',
    error_reading_files: 'Fehler beim lesen der Datei',
    template_import_error: 'Fehler beim Vorlagen Import',
    number_of_templates_imported_successfully: 'Zahl der erfolgreich importierten Vorlagen',
    number_of_templates_not_imported: 'Zahl der nicht importierten Vorlagen',
    choose_template: '',
    download_preview: 'Vorschau herunterladen',
    copy_to_clipboard: 'Kopieren'
  },
  promocodes: {
    category_name: 'Kategoriename',
    promo_code_name: 'Gutscheinname',
    remove_all_of_unused_promotional_codes: 'Alle unbenutzte Gutscheine löschen',
    for_all_time: 'Für die ganze Zeit',
    promotion_codes_deleted: 'Gelöschte Gutscheine:',
    promotional_codes_uploaded: 'Hochgeladene Gutscheine: ',
    rewritten_promo_codes: 'Überschriebene Gutscheine: ',
    files_entries_that_already_in_the_database: 'schon in der Data Base vorhanden: ',
    no_loyalty_categories_with_names: 'keine Loyalitätskategorie mit den Namen: ',
    removed: 'Gelöscht',
    select_file: 'File wählen',
    select_a_category_to_delete: 'Kategorie zu löschen',
    email_must_be_different: 'Die E-Mails müssen verschieden sein',
    mail_for_alerts_updated: 'Die E-Mail für die Benachrichtigung ist erneuert',
    are_you_sure_you_want_to_keep_current_mail: 'Wollen Sie die E-Mail speichern?',
    are_you_sure_you_want_to_delete_the_current_mail: 'Wollen Sie sie die E-Mail löschen?',
    delete_email_for_alerts: 'E-Mail für die Benachrichtigung löschen',
    save_email_for_alerts: 'E-Mail für die Benachrichtigung speichern',
    search: 'Suche',
    delete_everything: 'Alle löschen',
    delete_promotional_codes: 'Gutscheine löschen',
    remaining_promotional_codes: 'Noch vorhanden',
    used_promotional_codes: 'Gebrauchte',
    all_promotional_codes: 'Alle Gutscheine',
    active_email: 'Jetzige E-Mail',
    enter_new_email: 'Neue E-Mail',
    are_you_sure_you_want_to_remove_the_promotional_codes_from_the_category:
      'Wollen Sie wirklich die Gutscheine aus der Kategorie löschen',
    are_you_sure_you_want_to_delete_all_promotional_codes:
      'Wollen Sie wirklich alle Gutscheine löschen?',
    date_of_download: 'Hochladedatum',
    are_you_sure_you_want_to_remove_the_promotional_code:
      'Wollen Sie wirklich den Gutschein löschen',
    overwrite_existing_ones_by_making_them_available:
      'Gutscheine überschreiben und wiederbenutzten',
    import_promotional_codes: 'Gutscheine importieren',
    editing_mail_for_alerts: 'E-Mail für Benachrichtigungen bearbeiten',
    promotion_code_text_email:
      'Geben Sie eine E-Mail an, um benachrichtigt zu werden, falls die Gutscheine ausgehen',
    promotion_code_statistics: 'Gutscheinstatistik',
    remove_promotional_code: 'Gutschiene löschen',
    remove_promotional_codes: 'Gutscheine löschen',
    promotional_code: 'Gutscheine',
    category: 'Kategorie',
    date_of_use: 'Verwendungsdatum',
    date_added_to_the_site: 'Hinzufügungsdatum',
    download_statistics: 'Statistik herunterladen',
    download_promotional_codes: 'Gutscheine herunterladen',
    download_instructions: 'Anleitung runterladen',
    the_file_format_must_be_csv: 'Das Dateiformat muss CSV sein'
  },
  offers: {
    store_offers: 'Produkte',
    price: 'Preis',
    update_date: 'Aktualisierungsdatum',
    vendor: 'Verkäufer',
    available: 'Auf Lager',
    description: 'Beschreibung',
    model: 'Model'
  },
  reports: {
    compare_selected: '',
    clicks: '',
    purchases: '',
    attribution: 'Atribution',
    attributions: 'Atribution',
    by_orders: '',
    leadhit_service_reports: 'Berichte über den LeadHit Service',
    end_to_end_analytics: 'End-to-End-Analyse',
    multi_report: 'Mulitibericht',
    download: 'Download',
    sources_of_orders: 'Bestellquellen',
    statistics: 'Statistik',
    recommendations_report: 'Empfehlungsberichte',
    emails_report: 'Trigger E-Mail Bericht',
    multichannel: 'Multikanal',
    split_into_groups: 'Nach Gruppen aufteilen',
    download_report: 'Bericht laden',
    choose_filter: 'Filter wählen',
    recommendation_report_exclude_empty_data: 'Bestellungen ohne Nummer oder Summe ausschließen',
    select_action: 'Aktion wählen',
    autocasts_report: 'Newsletter Bericht',
    after_receiving_email: 'Nach erhalt einer E-Mail',
    report_type: 'Berichtstyp',
    mailings_type: 'E-Mail Typ',
    leadhit_efficiency_report: 'Bericht über die LeadHit Effektivität',
    active: 'Aktive',
    inactive: 'Unaktive',
    channel: 'Kanal',
    attribution_channel: 'Atributionskanal',
    orders_amount: 'Verkaufssumme',
    orders: {
      click_time: '',
      order_number: 'Bestellnummer',
      total_amount: '',
      number: 'Nummer',
      source: 'Quelle',
      time_added: 'Bestelldatum',
      order_sum: 'Bestellsumme',
      sum: 'Summe',
      information_about_order: 'Information über Bestellung',
      client: 'Kunde',
      product_list: 'Produktliste',
      no_products: 'Die Produkte fehlen',
      amount: 'Zahl',
      total_number_orders: 'Zahl der Bestellungen',
      total: 'Gesammt',
      exclude_orders_without_number_or_amount:
        'Bestellungen one Nummer oder Summe aus dem Bericht ausschließen',
      display_unprocessed_order_amounts: 'Unverarbeitete Bestellbeträge anzeigen',
      do_not_display_lead_orders_with_manager_status:
        'Bestellungen mit “Manager” Status im Bericht ausblenden',
      source_grouping: 'Quellen'
    },
    diagram_order_count: '',
    diagram_total_sum: '',
    period_total: ''
  },
  analytic: {
    you_can_select_only_one_type_of_widget: 'Es kann nur eine Widgetart gewählt werden!',
    you_can_select_only_one_widget: 'Es kann nur ein Widgettyp gewählt werden!',
    you_can_select_only_one_autocast: 'Nicht mehr als ein Newsletter!',
    you_can_select_only_one_widget_recommendation:
      'Es kann nur ein Empfehlungs Widget gewählt werden!',
    message_campaigns_selected: 'Es können maximal 6 Newsletter ausgewählt werden!',
    by_leads: 'Leads',
    traffic_source: 'Traffic Quellen',
    diagram: 'Diagramm',
    channel_groups: 'Gruppe der Quellen',
    social_networks: 'Soziale Netzwerke',
    search_engines: 'Suchmaschinen',
    advertising: 'Werbung',
    other: 'Andere',
    no_type: 'Kein Typ',
    all_traffic: 'Aller Traffic',
    compare_periods: 'Intervalle vergleichen',
    by_unique_events: 'Nach eindeutigen Ereignissen',
    period: 'Intervall',
    total_per_period: 'Gesamt für den Zeitraum',
    choose_emails: 'E-Mail Kampanie wählen',
    open_list: 'Liste öffnen',
    selection_widget_recommendations: 'Empfehlung Widget wählen',
    recommendation_widget_analytics: 'Analytik aller Produkt Emofehlungen',
    recommendation_widget_popup_title: 'Wählen Sie ein Empfehlungs Widget',
    clicked_on_recommendations_widget: 'Haben auf eine Empfehlung geklickt',
    order_sum_after_click_widget_recommendation:
      'Bestellsumme nach einem Klick auf eine Empfehlung',
    orders_after_click_widget_recommendation: 'Bestellungen nach einem Klick auf Empfehlungen',
    choose_widget: 'Wählen Sie ein Widget',
    recommendations_data: 'Empfehlungsdaten',
    choose_recommendation_widget: 'Empfehlung Widget wählen',
    lead_analytics: 'Lead Analytik',
    choose_autocast_by_name: 'Newsletter auswählen',
    select_least_one_autocast: 'Wählen Sie mindestens ein Newsletter',
    total_sales: 'Verkaufe insgesamt',
    total_revenue: 'Gesamterlös',
    sales: 'Verkaufe',
    revenue_share: 'Erlösteil',
    store_sales: 'Eigenverkäufe',
    total_amount_orders: 'Gesamtsumme der Verkaufe',
    widget_analytics: 'Widgetanalytik',
    choose_widget_name: 'Widgetname wählen',
    choose_widget_type: 'Wählen Sie den Widgettyp',
    select_widget_type_to_compare: 'Widgettyp zum Vergleich auswählen',
    choose_one_of_widgets_by_name: 'Wählen Sie ein Empfehlungs Widget',
    widget_data: 'Widgetdaten',
    condition_receiving_data: 'Bedingung zu Datenerhalt',
    other_sources: 'Andere Quellen',
    on_unique_visits: 'unikale Besuche',
    on_unique_leads: 'unikale Leads',
    leads_unsubscribed_from_all_mailings: 'Zahl der von allem abgemeldete Leute',
    amount_of_new_leads: 'Zahl der neuen Kunden',
    unsubscribed_discovered_leads_ratio: 'Zahl abgemeldeten Leute / Zahl der neuen Kunden',
    total_sent: 'Zahl der abgesendeten E-Mails',
    total_opened: 'Zahl der geöffneten E-Mails',
    total_clicked: 'Zahl der angeklickten Links in den E-Mails',
    conversion: 'Konversion',
    absolute_conversion: 'Absolute Konversion',
    goods_that_are_most_often_bought: 'Produkte, die am häufigsten gekauft werden',
    goods_that_are_most_often_added_to_cart_but_not_bought:
      'Produkte, die am häufigsten in den Warenkorb gelegt aber nicht gekauft werden',
    goods_that_are_most_often_viewed: 'Produkte, die am häufigsten angesehen werden',
    goods_that_are_most_often_viewed_but_not_bought:
      'Produkte, die am häufigsten angesehen, aber nicht gekauft werden',
    offer_name: 'Produktname',
    number_of_purchases: 'Zahl der Käufe',
    number_of_cart_additions: 'Anzahl der Hinzufügungen zum Warenkorb',
    number_of_views: 'Anzahl der Aufrufe',
    website_page: 'Seite auf der Website',
    period_cannot_be_more_than_one_month: 'Die Zeitspanne kann nicht länger als ein Monat sein',
    kpi: {
      arpv_definition:
        'durchschnittliche Kosten eines Besuchers. Viefiel Euro bringt durchschnittlich ein Besucher',
      revenue: 'Erträge',
      traffic_volume_visitor: 'Zahl der Besucher',
      arpl_definition: 'durchschnittliches Einkommen durch einen Lead',
      traffic_volume_lids: 'Traffic (Leads)',
      arppu_definition: 'durchschnittliches Einkommen durch einen Kunden',
      customers_who_made_order: 'Besucher, die was bestellt haben',
      average_check_definition:
        'durchschnittliche Zahl der Bestellungen von einem Kunde Ihrem Online-Shop',
      number_orders: 'Zahl der Bestellungen',
      purchase_rate_definition: 'durchschnittliche Kaufhäufigkeit von einem Kunden',
      number_unique_customers: 'Unikale Kunden',
      repeat_customer_rate_definition: 'Prozent der Stammkunden',
      number_unique_multi_customers: 'Unikale Kunden, die ein zweiten Kauf gemacht haben',
      car_definition: 'Prozent der vergessenen Warenkörbe',
      paid_offers_rate_definition: 'Anzahl der geformten Bestellungen zu gefüllten Warenkörben',
      number_of_bookings_orders: 'Zahl der geformten Bestellungen',
      number_of_paid_orders: 'Zahl der bezahlten Bestellungen',
      total_orders: 'Gesamtzahl der Bestellungen',
      orders_completed: 'Allgemeine ausführung der Bestellungen',
      income: 'Einkommen',
      orders: 'Bestellungen',
      carts: 'Warenkörbe'
    },
    sales_funnel_chart: {
      total_visits: 'Websitebesucher',
      total_offer_views: 'Anschaungen von Produktseiten',
      total_additions_to_cart: 'Warenkörbe mit Produkten',
      total_orders_made: 'Käufe'
    }
  },
  widget: {
    smart_offer: 'Smartoffer',
    social_proof: 'Social-Proof',
    subscribe: 'Subscription',
    wish_list: 'Wishlist',
    generic: 'gesamt',
    notification: 'Benachrichtigung',
    recommendations: 'Empfehlung'
  },
  instruments: {
    no_delay: 'Sofort',
    started: 'Gestartet',
    most_popular: 'Populärste',
    clicks: 'Klicks',
    open: 'Geöffnet',
    mailing_date: 'Versanddatum',
    delivered: 'Zugestellt',
    sent: 'Abgeschickt',
    newsletter_name: 'Newslettername',
    unsubscribed: 'Abgemeldet',
    last_activity: 'Letzte Aktivität',
    new_mass_email_campaign: 'Newsletter erstellen',
    new_trigger_email_campaign: 'Trigger E-Mail erstellen',
    autocast_name: 'E-Mail Name',
    email_template: 'E-Mail Vorlage',
    sender_name: 'Absender Name',
    sender_address: 'Absender E-Mail',
    email_subject: 'E-Mail Thema',
    dispatch_delay: 'Sendeverzögerung (Minuten)',
    dispatch_interval: 'Sendeintervall (Stunden)',
    time_after_last_order: 'Intervall zur letzten Bestellung (Stunden)',
    autocast_type: 'E-Mail Typ',
    linked_widget: 'Zugehöriges Widget (optional)',
    do_not_send_emails: 'E-Mails nicht abschicken',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Für den Versand des Newsletters ist Double opt in erforderlich',
    disable_the_banner_display_when_email_is_clicked:
      'Banner bei übergängen aus der E-Mail deaktivieren',
    periodical: 'Periodisch',
    hour_of_dispatch: 'Abschickzeit',
    per_day_emails_upper_limit: 'Maximale Anzahl von E-Mails pro Tag',
    delivery_days: 'Versandtage',
    conditions: 'Bedingung',
    a_b_testing: 'A/B Tests',
    add_a_test: 'Test hinzufügen',
    testing_name: 'Testname',
    choose_autocast: 'Trigger E-Mail auswählen',
    choose_template: '',
    more: 'Zusäzlich',
    and: 'und',
    or: 'oder',
    contains: 'Enthält',
    does_not_contain: 'Enthält nicht',
    test_autocast: 'Test E-Mails',
    sending_time: 'Versandszeitpunkt',
    chunk_size: 'Absendezeit',
    interval_between_segments: 'Intervall zwischen den Segmenten',
    provider: 'Provider',
    to: 'Wem',
    address: 'Adresse',
    list_name: 'Listenname',
    campaign_settings: 'Newsletter Parameter',
    email: 'Empfänger',
    enter_name_of_autocast: 'Wählen Sie ein Name',
    enter_name_of_emails: 'Newsletter Name eingeben',
    alert:
      'Wählen Sie einen Parameter oder eine Gruppe von Parametern aus, um die Newsletter zu erstellen',
    enter_value: 'Wert eingeben',
    choose_a_condition: 'Wählen Sie eine Bedingung',
    target_audience: 'Zielmailing',
    enter_motivation: 'Motivation eingeben',
    enter_instruction: 'Anleitung eingeben',
    enter_test_mail_recipient_addresses: 'Empfänger der Test E-Mails',
    send_test_emails: 'Test E-Mails senden',
    send_test_emails_for_autocast: 'Test E-Mails für die Newsletter senden',
    send_test_emails_for_selected_emails: 'Test E-Mails für die gewählten E-Mails senden',
    enter_test_number: 'Nummer des Tests eingeben',
    emails_creation_date: 'Erstellungsdatum',
    autocast_creation_date: 'Erstelldatum der Träger E-Mails',
    date_modified: 'Letzte Verändrungen',
    sample: 'Auslese',
    emails_total: 'E-Mails insgesammt',
    emails_delivered: 'Zugestellt',
    pending: 'Werden gerade abgeschickt',
    delivery_errors: 'Zustellungsfehler',
    to_send: 'Warten auf Versand',
    opened: 'Geöffnete E-Mails',
    clicked: 'Link Klicks',
    web_preview: 'Web Ansicht',
    recipients: 'Empfänger',
    include_test_emails: 'Test E-Mail mitberechnen?',
    filters: 'Filter',
    date: 'Absanddatum',
    delivery_date: 'Zustellungsdatum',
    dispatch_time: 'Versandszeitpunkt',
    time_of_delivery: 'Zustellungszeitpunkt',
    information_about_emails: 'Information über die Newsletter',
    information_about_webpush: 'Information über die Webpush-Kampagne',
    webpush_total: 'Push insgesamt',
    webpush_sent: 'Gesendet',
    webpush_shown: 'Angezeigt',
    webpush_clicked: 'Klicks',
    webpush_closed: 'Ohne Klick geschlossen',
    webpush_dismissed: 'Ohne Klick geschlossen',
    webpush_crashed: 'Zustellfehler',
    webpush_statuses: {
      new: 'Wartet auf Versand',
      processing: 'In Bearbeitung',
      sent: 'Gesendet',
      shown: 'Angezeigt',
      clicked: 'Geklickt',
      closed: 'Geschlossen',
      dismissed: 'Geschlossen',
      crashed: 'Fehler'
    },
    information_about_autocast: 'Information über die Trigger E-Mails',
    take_into_account_activity_during_the_delay_period:
      'Verfolgen Sie die Aktivität über den Verzögerungszeitraum',
    choose_a_condition_block: 'Wählen Sie einen Bedingungsblock aus',
    multilead_is_created: 'Multilead wurde erstellt',
    multilead_order_status: 'Bestellungen',
    multilead_status: 'Multileadstatus',
    order_status: 'Bestellstatus',
    visit_is_active: 'Aktive Besucher',
    email_status: 'Newsletter Status',
    days_since_last_buy: 'Tage seit der letzten Bestellung (wenn vorhanden)',
    days_since_purchase: 'Tage seit der letzten Bestellung',
    offer_purchase_period: 'Bestellperioden',
    periodic_purchase_last_update: 'Tage seit dem letzten wiederkehrenden Kauf',
    days_before_next_predictable_periodic_purchase: 'Tage vor dem nächsten regelmäßigen Kauf',
    days_after_skipped_periodic_purchase: 'Tage nach verpasstem wiederkehrenden Kauf',
    not_attend: 'Nicht besucht (Tage)',
    days_to_birthday: 'Bis zum Geburtstag (Tage)',
    subscription_type: 'Abonnementtyp',
    email_contains: 'E-Mail',
    visit_type: 'Besuchsart',
    form_submitted: 'Ausgefüllte Form',
    visited_page: 'Besuchte Seiten',
    check_if_parameters_are_set_properly: 'Überprüfen Sie die Richtigkeit der Parameter',
    check_if_parameters_are_set_properly_for_conditions_block:
      'Überprüfen Sie die Richtigkeit des Bedingungsblocks',
    error_save_autocast: 'Fehler beim Speichern der Trigger E-Mails',
    the_value_must_be_numeric: 'Die Eingabe muss eine Zahl sein',
    enter_a_valid_email: 'Geben Sie ein korrekte E-Mail an',
    no_template_selected: 'Keine Vorlage gewählt',
    the_field_must_be_between_1_and_31: 'Das Feld muss einen Wert zwischen 1 und 31 entsprechen',
    the_field_must_be_between_1_and_23: 'Das Feld muss einen Wert zwischen 1 und 23 entsprechen',
    maximum_nesting_level: 'Maximale Höhe der Ebenen',
    maximum_number_of_blocks: 'Maximale Blockzahl',
    maximum_number_of_conditions: 'Maximale Zahl der Bedingungen',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Zum Abschicken muss eine Bestätigung des Abo vorhanden sein',
    purchased_offer: '',
    unopened_mass_messages: '',
    opened_mass_messages: '',
    last_mass_messages_count: '',
    multilead_message: '',
    auto_cust: {
      limitation_email: '',
      choose_email: '',
      choose_ab_test: '',
      send_test_success: '',
      is_active: 'Aktiv',
      the_number_cannot_be_more_than: 'Die Zahl kann nicht größer sein als',
      the_maximum_number_of_characters: 'Maximale Zahl an Zeichen',
      no_last_activity: 'Keine letzten Aktivitäten',
      autocast_has_been_archived: 'Trigger E-Mail wurde archiviert',
      autocasts_has_been_archived: 'Trigger E-Mails wurden archiviert',
      autocast_has_been_unarchived: 'Trigger E-Mail wurde unarchiviert',
      autocasts_has_been_unarchived: 'Trigger E-Mails wurden unarchiviert',
      autocast_has_been_activated: 'Trigger E-Mail wurde aktiviert',
      autocasts_has_been_activated: 'Trigger E-Mails wurden aktiviert',
      autocast_has_been_deactivated: 'Trigger E-Mail wurde deaktiviert',
      autocasts_has_been_deactivated: 'Trigger E-Mails wurden deaktiviert',
      archive_autocast: 'Newsletter unarchivieren',
      unarchive_autocast: 'Newsletter archivieren',
      deactivate_autocast: 'Newsletter aktivieren',
      active_autocast: 'Newsletter deaktivieren',
      must_select_at_least_1_autocast: 'Es muss mindestens 1 Newsletter gewählt sein',
      selected_autocast: 'Gewählte Newsletter',
      deactivate: 'Dealtivieren',
      activate: 'Aktivieren',
      unarchive: 'Unarchivieren',
      archive: 'Archivieren',
      show_archived_mailing_campaigns: 'Archivierte Newsletter anzeigen',
      hide_archived_mailing_campaigns: 'Archivierte Newsletter ausblenden',
      add_a_condition: 'Bedungung hinzufügen',
      add_a_conditions_block: 'Bedingungen hinzufügen',
      paid: 'Bezahlt',
      submitted: 'Zugestellt',
      delivered: 'Zugestellt',
      cancelled: 'Abgebrochen',
      daily: 'Täglich',
      visits: 'Besuche',
      view: 'Produkt Ansichten',
      cart: 'Warenkorb',
      pre_order: 'Anfang der Bestellung',
      order: 'Bestellung',
      category_view: 'Ansicht von Kategorien',
      unavailable_view: 'Ansicht von nichtvorhandene Produkten',
      in_stock: 'Auf Lager',
      discount: 'Preissenkung',
      day_of_week: 'Wochentag',
      day_of_month: 'Monatstage',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      starts_with: 'Fängt an mit',
      does_not_start_with: 'Fängt nicht an mit',
      did_not_visit_in_days: 'Nicht Besucht (Tage)',
      statistics_for_ab_testing: 'A/B Test Statistik',
      lacking_ab_testing: 'Keine A/B Tests',
      enter_day_of_month: 'Tag des Monats',
      copy_autocast: 'E-Mail kopieren | E-Mails kopieren | E-Mails kopieren',
      autocast_with_that_name_already_exists: 'Eine E-Mail mit diesem Namen git es schon',
      autocast_successfully_copied: 'Die E-Mail wurden kopiert',
      autocasts_successfully_copied: 'Die E-Mails wurden kopiert',
      enter_name_of_new_autocast:
        'Geben Sie ein Name für die neue E-Mail an | Geben Sie Namen für die neuen E-Mails an | Geben Sie Namen für die neuen E-Mails an',
      default_values: 'Standardwerte',
      set_default_values: 'Standardwerte definieren',
      defaults_values_changed: 'Die Standardwerte wurden verändert',
      apply_defaults_values: 'Standardwerte anwenden',
      apply_defaults_values_question:
        'Sind Sie sicher, dass Sie die Standardwerte mit der ausgewählten E-Mail benutzen wollen | Snd Sie sicher, dass Sie die Standardwerte mit den ausgewählten E-Mails benutzen wollen | Snd Sie sicher, dass Sie die Standardwerte mit den ausgewählten E-Mails benutzen wollen',
      selected_autocast: 'Gewählte E-Mail | Gewählte E-Mails | Gewählte E-Mails',
      you_must_set_at_least_one_default_value: 'Es muss mindestens ein Wert festgelegt werden',
      autocast_successfully_updated: 'Die E-Mail würden aktualisiert',
      autocasts_successfully_updated: 'Die E-Mails würden aktualisiert',
      email_statuses: {
        delivered: 'Zugestellt',
        dropped: 'Zustellungsfehler',
        opened: 'Geöffnet',
        new: 'Werden noch abgesendet',
        sent: 'Zustellungsversuch'
      }
    },
    ab_test: {
      active_ab_testing: 'Aktive A/B Tests',
      ab_testing: 'A/B Tests',
      autocast: 'Trigger E-Mail',
      create_ab_test: 'A/B Test erstellen',
      test_name: 'Testname',
      required_field: 'Pflichtfeld',
      enter_a_valid_value: 'Korrekte Bezeichnung angeben',
      mandatory_to_choose: 'Pflichtfeld',
      validation_not_passed: 'Validierung fehlgeschlagen',
      no_change: 'Keine Veränderungen',
      save_changes_to_autocast: 'Veränderungen speichern',
      saving_changes: 'Speicherung',
      amount_must_be_no_more: 'Die Summe kann nicht größer sein als',
      data_saved: 'Die Daten wurden gespeichert'
    },
    message_campaign: {
      sender_mail: 'Absender E-Mail',
      select_channel: 'Versandkanal auswählen',
      template_selection: 'Vorlage',
      disable_banner_display: 'Banner bei übergängen aus der E-Mail deaktivieren',
      segment_size: 'Größe des Segments',
      segmant_delay: 'Intervale zwischen den Segmenten',
      single_address: 'Einzeladresse',
      segment_name: 'Segmentname',
      lead_id: 'Lead-ID',
      parameter_is_optional: 'Parameter ist nicht erforderlich',
      segment_size_delay_condition:
        'Segmentgröße und Intervalle zwischen den Segmente müssen entweder beide ausgefüllt sein oder keine der beiden',
      create_email_question: 'Wollen Sie wirklich ein Newsletter erstellen',
      error_create_email: 'Fehler beim erstellen',
      email_success_created: 'Newsletter erstellt',
      network_error_check_manually: 'Ein Netzwerkfehler ist aufgetreten. Der Newsletter wurde möglicherweise erfolgreich erstellt. Bitte überprüfen Sie die Newsletter-Liste oder versuchen Sie es erneut.',
      delete_no_permission: 'Keine Berechtigung, diese Kampagne zu löschen',
      delete_not_found: 'Kampagne nicht gefunden'
    },
    widgets: {
      error_config_file: '',
      export_config_success: '',
      import_config: '',
      export_config: '',
      delete_widget: 'Widget löschen | Widget löschen | Widget löschen',
      confirm_popup_delete_body_text:
        'Wollen Sie das gewählte Widget wirklich löschen | Wollen Sie die gewählten Widget wirklich löschen | Wollen Sie die gewählten Widget wirklich löschen',
      copy_widget: 'Widget kopieren | Widgets kopieren | Widgets kopieren',
      confirm_popup_copy_body_text:
        'Name des neuen Widgets | Name der neuen Widgets | Name der neuen Widgets',
      name_selected_widget:
        'Name des gewählten Widgets | Name der gewählten Widgets | Name der gewählten Widgets',
      action_selection: 'Handlung wählen',
      actions_not_available_until_you_select_widgets:
        'Die Handling ist nicht zugänglich solang kein Widget gewählt ist',
      widget_name: 'Widget Name',
      active: 'Aktiv',
      not_active: 'Nicht Aktiv',
      launch_date: 'Start Datum',
      activate_widget: 'Widget aktivieren',
      deactivate_widget: 'Widget deaktivieren',
      confirm_popup_activate_body_text: 'Wollen Sie das gewählte Widget wirklich aktivieren',
      confirm_popup_deactivate_body_text: 'Wollen Sie das gewählte Widget wirklich deaktivieren',
      widget: 'Widget',
      enter_widget_name: 'Widgetname eingeben',
      widget_type: 'Widget typ',
      widget_creation: 'Widget erstellung',
      widget_editing: 'Widget bearbeiten',
      json_config: 'JSON Konfiguration',
      widget_on: 'Widget ist aktiv',
      widget_off: 'Widget abgeschaltet',
      basic_settings: 'Haupteinstellungen',
      variables: 'Variablen',
      code: 'Code',
      triggers: 'Trigger',
      choose_display_conditions: 'Wählen Sie eine Anzeigebedingung',
      widget_group: 'Widgetgruppe',
      trigger: 'Trigger',
      timer: 'Timer',
      value: 'Bezeichnung',
      idle_timer: 'Inaktivitäts-Timer',
      mouse_out: 'Die Maus wurde ins Auserhalb des Bildschirms bewegt',
      localStorageKey: 'Schlüssel LocalStorage',
      parameters: 'Parameter',
      cookie: 'Cookie',
      localstorage_variable: 'LocalStorage Variabele',
      global_variable: 'Global Variable',
      type: 'Typ',
      select_type: 'Typ wählen',
      select_name: 'Name wählen',
      operator: 'Operator',
      page_url: 'Weg zu Seite',
      pages_viewed: 'Angesehene Seite',
      widget_shown: 'Angezeigte Widgets',
      more: 'Mehr',
      less: 'Weniger',
      contain_regexp: 'Enthält RegExp',
      not_contain_regexp: 'Enthält RegExp nicht',
      name_of_new_widget: 'Name des neuen Widgets',
      widget_was_removed: 'Das Widget wurde gelöscht',
      widgets_was_removed: 'Die Widgets wurden gelöscht',
      variable_assignment: 'Variablenzuordnung',
      variable_name: 'Name der Variablen',
      widget_updated_successfully: 'Das Widget wurde erneuert',
      widget_locked_by_another_user: 'Das Widget wird bereits von einem anderen Benutzer bearbeitet',
      widget_lock_error: 'Das Widget konnte nicht gesperrt werden',
      no_abtests: 'Keine A/B Tests vorhanden',
      active_abtests: 'Aktive Tests',
      finished_abtests: 'Abgeschlossene Tests',
      no_finished_abtests: 'Keine abgeschlossenen Tests',
      start_date: 'Startdatum',
      activity_period: 'Aktivitätszeitraum',
      test_statistics: 'Teststatistik',
      metric: 'Metrik',
      finish_test: 'Test beenden',
      finishing_abtest: 'Test "{name}" beenden',
      finish_abtest_hint: 'Wählen Sie die Widgets aus, die nach dem Test aktiv bleiben sollen.\nStandardmäßig werden alle Widgets des Tests beim Beenden deaktiviert.',
      keep_in_work: 'Aktiv lassen',
      abtest_successfully_finished: 'A/B Test wurde erfolgreich beendet',
      abtest_finish_error: 'A/B Test konnte nicht beendet werden',
      abtest_stats_error: 'Teststatistik konnte nicht geladen werden',
      stats_metrics: {
        popup_view: 'Popup-Ansichten',
        popup_view_3s: 'Popup-Ansichten 3 Sek.',
        popup_view_10s: 'Popup-Ansichten 10 Sek.',
        close: 'Schließen',
        fill: 'Formularausfüllungen',
        conversion: 'Konversion'
      },
      delete_test: 'Test löschen',
      enter_test_name: 'Name des Tests',
      abtest_title: 'Wählen Sie eine Gruppe und einen Namen für den Test',
      add_widget: 'Widget hinzufügen',
      share_of_show: 'Anteil an Erscheinungen',
      no_widgets: 'Keine Widgets vorhanden',
      all_tests_must_contain_widgets: 'Der Test muss mindestens 2 Widgets enthalten',
      not_all_share_show_widget_current: 'Die Summe der Anteile muss gleich 100 sein',
      are_you_sure_you_want_to_remove_abtest: 'Wollen Sie wirklich den A/B Test löschen',
      removing_abtest: 'Löschung vom A/B Test',
      abtest_successfully_deleted: 'Der A/B Test wurde gelöscht',
      name_selected_abtest: 'Name des gewählten A/B Tests',
      abtest_saved: 'A/B Test wurde gespeichert',
      choose_value: 'Wählen Sie einen Wert',
      activate_at_least_two_widgets: 'Mindestens 2 Widgets müssen aktiv sein',
      fill_in_empty_test: 'Der leere Text muss ausgefüllt werden',
      widget_name_is_exist: ''
    },
    alerts: {
      user_alerts: 'Nutzer Benachrichtigung',
      history: 'Verlauf',
      сreate_alert: 'Benachrichtigung erstellen',
      user_alert: 'Nutzerbenachrichtigung',
      alert_name: 'Benachrichtigungsname',
      user_alert_editor_notification_text:
        'Wählen Sie ein Parameter oder eine Gruppe an Parametern um eine Benachrichtigung zu erstellen',
      send_to_mail: 'Als E-Mail schicken',
      alert_parameters: 'Benachrichtigungsoptionen',
      sender: 'Absender',
      send_only_with_phone: 'Nur wen eine Telefonnummer enthalten ist schicken',
      send_again: 'Erneut senden',
      webhook_alert: 'Benachrichtigung per Webhook' ,
      number_of_visits: 'Zahl der Besuche',
      lead_mail_is_correct: 'Die Lead E-Mail ist korrekt',
      delete_user_alert:
        'Nutzerbenachrichtigung löschen | Nutzerbenachrichtigungen löschen | Nutzerbenachrichtigungen löschen',
      confirm_popup_delete_body_text:
        'Wollen sie wirklich die Nutzerbenachrichtigung löschen | Wollen sie wirklich die Nutzerbenachrichtigungen löschen | Wollen sie wirklich die Nutzerbenachrichtigungen löschen',
      name_selected_user_alert:
        'Name der gewählten Nutzerbenachrichtigung | Name der gewählten Nutzerbenachrichtigungen | Name der gewählten Nutzerbenachrichtigungen',
      user_alert_was_removed: 'Nutzerbenachrichtigung wurde gelöscht',
      user_alerts_was_removed: 'Nutzerbenachrichtigungen wurden gelöscht',
      user_alert_updated_successfully: 'Nutzerbenachrichtigungen wurden gelöscht',
      activate_user_alert:
        'Nutzerbenachrichtigung aktivieren | Nutzerbenachrichtigungen aktivieren | Nutzerbenachrichtigungen aktivieren',
      confirm_popup_activate_body_text:
        'Wollen Sie wirklich die gewählt Nutzerbenachrichtigung aktivieren | Wollen Sie wirklich die gewählten Nutzerbenachrichtigungen aktivieren | Wollen Sie wirklich die gewählten Nutzerbenachrichtigungen aktivieren',
      user_alerts_updated: 'Nutzerbenachrichtigung wurde erneuert',
      user_alert_updated: 'Nutzerbenachrichtigungen wurde erneuert',
      deactivate_user_alert:
        'Nutzerbenachrichtigung deaktivieren | Nutzerbenachrichtigungen deaktivieren | Nutzerbenachrichtigungen deaktivieren',
      confirm_popup_deactivate_body_text:
        'Wollen Sie wirklich die gewählten Nutzerbenachrichtigung deaktivieren | Wollen Sie wirklich die gewählten Nutzerbenachrichtigungen deaktivieren | Wollen Sie wirklich die gewählten Nutzerbenachrichtigungen deaktivieren',
      lead_name: 'Leadname',
      lead_mail: 'Lead E-Mail',
      lead_phone: 'Lead Telefonnummer',
      no_mail: 'Keine E-Mail',
      no_phone: 'Keine Telefonnummer',
      delete_user_alert_notification:
        'Nutzerbenachrichtigung löschen | Nutzerbenachrichtigungen löschen | Nutzerbenachrichtigungen löschen',
      confirm_popup_delete_notification_body_text:
        'Wollen Sie die gewählte Benachrichtigung wirklich löschen | Wollen Sie die gewählte Benachrichtigungen wirklich löschen | Wollen Sie die gewählte Benachrichtigungen wirklich löschen',
      name_selected_user_alert_notification:
        'Name der gewählten Benachrichtigung | Name der gewählten Benachrichtigungen | Name der gewählten Benachrichtigungen',
      notifications_deleted: 'Benachrichtigungen gelöscht',
      notification_deleted: 'Benachrichtigung gelöscht',
      download_to_csv: 'Als CSV laden',
      export_csv_user_alert_notification:
        'Benachrichtig als E-Mail schicken | Benachrichtigen als E-Mail schicken | Benachrichtigen als E-Mail schicken',
      sort_field: 'Sortierrichtung',
      sort_direction: 'Sortierrichtung'
    },
    subscriptions: {
      product_subscriptions: 'Produktabonnements',
      description: 'Verwaltung von Benutzerabonnements für Benachrichtigungen über Rabatte und Produktverfügbarkeit',
      no_subscriptions: 'Noch keine Abonnements',
      no_subscriptions_description: 'Hier werden Benutzerabonnements für Rabatt- und Produktverfügbarkeitsbenachrichtigungen angezeigt',
      subscription_type: 'Abonnement-Typ',
      search_by: 'Suchen nach',
      subscription_period: 'Abonnement-Zeitraum',
      search: 'Suchen',
      all_types: 'Alle',
      price_drop: 'Preissenkung',
      availability: 'Produktverfügbarkeit',
      email: 'E-Mail',
      offer_name: 'Produktname',
      product: 'Produkt',
      type: 'Typ',
      date: 'Abonnement-Datum',
      time_added: 'Hinzugefügt am',
      time_activated: 'Aktiviert am',
      actions: 'Aktionen',
      discount: 'Rabatt',
      base_price: 'Preis',
      discount_size: 'Rabatthöhe',
      status: 'Status',
      ready: 'Bereit',
      not_ready: 'Nicht bereit'
    },
    loyalty: {
      loyalty: 'Loyalität',
      rules: 'Algorythmen',
      loyalty_categories: 'Loyalität - Kategorien',
      loyalty_rules: 'Loyalität – Algorithmen',
      category_name: 'Kategorienname',
      discount_in_percent: 'Rabatt in %',
      discount_size: 'Rabattsatz',
      create_new_category: 'Neue Kategorie erstellen',
      category_type: 'Kategorietyp',
      category_successfully_created: 'Kategorie wurde erstellt',
      delete_category: 'Kategorie löschen',
      confirm_popup_delete_category_body_text:
        'Sind Sie sicher, dass Sie die gewählte Kategorie löschen wollen',
      selected_category_name: 'Name der gewählten Kategorie',
      category_successfully_deleted: 'Kategorie wurde gelöscht',
      loyalty_category: 'Loyalitätskategorie',
      amount_of_purchases: 'Bestellsumme',
      select_conditions: 'Algorithmus wählen',
      value_must_be_integer_or_float: 'Der Wert muss eine ganze Zahl oder eine Dezimalzahl sein',
      rule_successfully_created: 'Algorithmus wurde erstellt',
      delete_rule: 'Algorithmus löschen',
      confirm_popup_delete_rule_body_text:
        'Sind Sie sicher, dass Sie den Gewählten Algorithmus löschen wollen',
      selected_rule_condition:
        'Bedingung für den gewählten Algorithmus | Bedingungen für den gewählten Algorithmus | Bedingungen für den gewählten Algorithmus',
      rule_successfully_deleted: 'Der Algorithmus wurde gelöscht'
    },
    business_rules: {
      title: '',
      add_business_rule: '',
      name_of_business_rule: '',
      name_of_business_rule_mobile: '',
      priority_rule: '',
      number_of_links: '',
      product: '',
      category: '',
      product_category: '',
      delete_rule: '',
      confirm_popup_delete_body_text: '',
      name_selected_rule: '',
      edit_business_rule: '',
      create_business_rule: '',
      rule_removed: '',
      configuration_selection: '',
      priority1: '',
      priority2: '',
      priority3: '',
      select_product: '',
      select_category: '',
      apply_with_recommendation: '',
      press_for_search: '',
      recommend_with_product: '',
      not_recommend_with_product: '',
      recommend_with_category: '',
      not_recommend_with_category: '',
      assigned_product_recommendation: '',
      start_searching_to_match: '',
      products_found: '',
      categories_found: '',
      recommendations_found: '',
      warning_not_selected_product: '',
      warning_not_selected_category: '',
      warning_not_selected_name_of_rule: '',
      changed_priority: '',
      rule_created: '',
      rule_updated: '',
      no_rights: ''
    },
    recommendation: {
      title: '',
      activate: '',
      deactivate: '',
      confirm_popup_activate_body_text: '',
      confirm_popup_deactivate_body_text: '',
      name_selected: '',
      name_of_service: '',
      algorithm: '',
      delete_recommendation: '',
      confirm_popup_delete_body_text: '',
      edit_recommendation: '',
      alert_success: '',
      alert_danger: '',
      only_available: '',
      name_filter: '',
      price_filter: '',
      recommendation_on: '',
      recommendation_off: '',
      recommendation_updated: ''
    }
  },
  datepicker: {
    periods: 'Zeitspannen',
    day: 'Tage',
    week: 'Woche',
    month: 'Monat',
    start_period: 'Anfang',
    end_period: 'Ende'
  },
  intro_training: {
    welcome_aboard: 'Willkommen!',
    marketing_management: 'Ihr Marketing Managment',
    start: 'Anfangen',
    later: 'Später',
    start_module_question: 'Wollen Sie die Funktionalität erklärt bekommen?',
    next: 'Weiter',
    scene_leads_first_text:
      'Im Tab “Leads” ist die Information über die Besucher enthalten, von denen wir Daten sammeln konnten.',
    scene_leads_second_text:
      'Die Daten können nach Traffic, Datum, Status sortiert werden. Jeder Lead hat ein Karte mit Details.',
    scene_leads_third_text:
      'Im Tab “Segmente” können Sie Gruppen erstellen, für die Sie gruppenspezifische Angebote erstellen könnt.',
    scene_instruments_first_text:
      'Hier finden Sie alle verfügbare Instrumente und deren aktuellen Status.',
    scene_instruments_second_text:
      'Hier können Sie die Instrumente steuern. Neue Pop ups erstellen, Vorlagen verändern und vieles mehr.',
    scene_instruments_third_text:
      'Zusammenfassung der Effektivität jedes Instruments. Die Informationen werden in Echtzeit aktualisiert.',
    scene_reports_first_text:
      'Alle verfügbaren Berichte werden hier zusammengefasst. Effizienz jeder einzelnen Produktempfehlung und jedes Pop ups.',
    scene_reports_second_text:
      'Überblicke über Effektivität von E-Mails – Empfangs Statistik, Open Rate, Click Rate und vieles mehr.',
    scene_reports_third_text:
      ' + Bonus – End-to-End-Analyse - zu Bewertung der Effektivität jedes Verkaufstkanal.',
    scene_analytics_first_text:
      'In der Analytik können Sie nicht nur die Effektivität von LeadHit sehen, sondern auch Effektivitätsparameter für Ihr Geschäft sehen.',
    scene_analytics_second_text:
      'Zusammenfassende Analysen in Form von Graphiken. Hier finden sie die Statistiken der Besuche, die Wachstumsdynamik, Anzahl der Leads, Statistiken zu Massen- und Trigger-Mailings sowie die Leistung von Widgets.',
    scene_analytics_third_text:
      'Jedes Widget kann erweitert werden so dass Sie detailliertes Bild jedes Parameters erhalten. Wählen Sie den erforderlichen Zeitraum, die Quelle und andere anpassbare Parameter aus.',
    scene_color_switcher_title: 'Helligketi ändern',
    scene_color_switcher_text:
      'Sie können wälen, ob Sie ein helles oder dunkelen Modus sehen wollen.',
    scene_settings_title: 'Einstellungen',
    scene_settings_text:
      'Zum Anfang empfehlen wir Ihnen die Benachrichtigungen so einzustellen, wie es für Sie am praktischen erscheint. Hier können Sie auch Zugänge verwalten und Instrumente einschalten.',
    continue_later: 'Später fortsetzen',
    control_training_buttons_text: 'Sie können mit folgenden Tasten die Tour steuern'
  },
  tariffs: {
    information_about_tariffs: 'Information über die Tarife',
    functionality: 'Funktionalität',
    per_month: 'Im Monat',
    on_the_leadhit_side: 'Auf der Seite von LeadHit',
    compatibility_check: 'Kompatibilität überprüfen',
    forms_connection: 'Formen anschließen',
    feed_check: 'Feed überprüfen',
    dns_preparation: 'DNS vorbereiten',
    connecting_postmasters: 'Postmaster anschließen',
    cross_domain_integration: 'Cross-Domain integration',
    finished_products: 'Fertige Produkte',
    smartoffer: 'Smartoffer',
    mobile_smartoffer: 'Mobile Smartoffer',
    triggered_mailings: 'Trigger E-Mails',
    abandoned_offer_view: 'Abgebrochene Besuch',
    wish_list: 'Wishlist',
    collection_of_personal_data: 'Erhebung personenbezogener Daten',
    abandoned_cart: 'Abgebrochene Bestellung',
    post_sale: 'Nachverkauf',
    inactive_client: 'Nichtaktive Kunde',
    subscribe_for_product_price_reduction: 'Benachrichtigung über Preissenkung',
    subscribe_for_product_availability:
      'Benachrichtigung über neue das Erscheinen vom Produkt auf Lager',
    average_bill_magnifier: 'Durchschnittliche Rechnung erhöhen',
    social_proof: 'Social proof',
    additional_features: 'Zusätzliche Möglichkeiten',
    standard_widget_templates: 'Standart Widget Vorlagen',
    adaptation_of_widgets_for_the_clients_site: 'Widget Anpassung für die Kundenwebseite',
    individual_algorithm_for_displaying_widgets: 'Individueller Widget Algorithmus',
    design_change: 'Design verändern',
    algorithms_change: 'Algorithmen verändern',
    ab_testing_of_widgets: 'A/B Widget Test',
    gamification: 'Gamification',
    individual_widget_design: 'Individueller Widget Design',
    working_with_different_types_of_clients: 'Mit verschiedenen Kundentypen arbeiten',
    limitations: 'Begrenzungen',
    once_monthly: 'Ein Mal/Monat',
    abandoned_view_of_an_expensive_product: 'Abgebrochene Ansicht von teueren Produkten',
    abandoned_view_of_products_out_of_stock: 'Abgebrochene Ansicht von nicht verfügbaren Produkten',
    welcome_series: 'Welcome E-Mails',
    nps_poll: 'NPS Umfrage',
    review: 'Bewertung',
    birthday: 'Geburtstag',
    abandoned_view_of_product_category: 'Abgebrochene Ansicht von Produktkategorien',
    products_of_regular_demand: 'Ständig gekaufte Produkte',
    regular_new_products: 'Reguläre Neulieferungen',
    regular_promotions: 'Reguläre Aktionen',
    transaction_mailings: 'Transaktions E-Mails',
    standard_email_templates: 'Standart E-Mail Vorlagen',
    visual_template_editor: 'Visueller Vorlageneditor',
    adaptation_of_emails_to_the_clients_site: 'E-Mail Anpassung für die Kundenwebseite',
    algorithm_change: 'Algorithmus verändern',
    individual_algorithm_of_trigger_mailings: 'Individuelle Algorithmen von trigger E-Mails',
    ab_testing_of_triggered_mailings: 'A/B Tests von trigger E-Mails',
    individual_promotional_codes_in_trigger_mailings: 'Individuelle Gutscheine in trigger E-Mails',
    individual_recommendations_in_triggered_mailings:
      'Individuelle Empfehlungen in trigger E-Mails',
    limitation_on_the_number_of_emails_received_by_lead:
      'Begrenzung der an einen Lead gesendeten E-Mails',
    support_of_regionalization: 'Unterstützung für Regionalität',
    individual_template_design: 'Individuelles Design der Vorlagen',
    configure_transactional_mailings: 'Einrichtung von transaktions E-Mails',
    limit_on_the_number_of_emails_sent_per_month_not_more_than: 'Newsletter Limit, nicht mehr als',
    welcome_series_consists_of_emails: 'Welcome E-Mails beinhalten … E-Mails',
    mass_mailings: 'Massen E-Mails',
    opportunities: 'Möglichkeiten',
    self_service_mailing: 'Eigene E-Mail',
    mailing_made_by_leadhit: 'LeadHit E-Mails',
    import_your_own_database: 'Kontakte importieren',
    verification_of_the_imported_database: 'Importierte Kontakte verifizieren',
    individual_recommendations_in_mass_mailings: 'Individuelle Empfehlungen in Newslettern',
    mailing_made_by_leadhit_per_month_no_more_if_you_need_more_often_contact_us:
      'E-Mail von LeadHit gemacht, nicht mehr als (falls mehr gebraucht werden, kontaktieren Sie uns)',
    verification_is_paid_additionally_depending_on_the_size_of_the_base:
      ' Die Verifikation der Kontakte wird einzelnd bezahlt',
    import_is_possible_strictly_after_verification:
      'Der Import ist nur nach der Verifikation möglich',
    recommendation_service_integration_by_api: 'Integration des Empfehlungsservice über API',
    service_integration_via_widget_by_leadhit:
      'Service Integration über ein widget, mit der Hilfe von LeadHit',
    setting_up_business_rules: 'Einstellung der Algorithmen',
    algorithms: 'Algorithmen',
    alarm_system: 'Benachrichtigungen',
    abandoned_cart_notifications: 'Benachrichtigungen über abgebrochene Bestellungen',
    ability_to_set_other_alerts: 'Möglichkeit andere Bestellungen einzurichten',
    project_support: 'Projekt Support',
    specialists: 'Spezialisten',
    account_manager: 'Account Manager',
    designer: 'Designer',
    copywriter: 'Copywriter',
    layout_designer: 'Layout designer',
    in_gap_tariff_support_available_on_ticket_system:
      'Im Gap-tarif ist der Support über das Ticket-System verfügbar',
    project_specialist_working_hours_are_limited_to_hours:
      'die Arbeitsstunden eines Spezialisten an einem Projekt sind auf ... Stunden beschränkt',
    add_info_email_marketing:
      'Der Tarif sieht keine Arbeit unserer Fachkräfte an den Newslettern vor. Falls das Interesses an einer komplexe Verwaltung von Newslettern  besteht, kontaktieren Sie uns bitte.',
    analytics_and_statistics: 'Analytik und Statistik',
    tariff_selection: 'Tarif wählen',
    lead_collection: 'Leads sammeln',
    converting_anonymous_visitors_to_leads: 'Anonyme Besucher zu Leads machen',
    base_collection: 'Kontakte sammeln',
    returning_customers_to_the_funnel: 'Kunden zum Kauf führen',
    personalization_of_trigger_mailings: 'Trigger E-Mail Personalisierung',
    working_with_mobile_traffic: 'Arbeit mit Mobilem Traffic',
    personalization_of_email_marketing_and_website: 'Webseiten Personalisierung',
    collecting_the_base_and_returning_customers_to_purchase:
      'Kontakten Sammeln und Kunden zum Kauf führen',
    customizing_email_marketing: 'Personalisierung des E-Mail Marketing',
    customizing_the_site: 'Personalisierung der Webseite',
    personalization_of_email_marketing_for_complex_scenarios:
      'E-Mail Personalisierung mit komplexen Szenarien',
    website_personalization_for_complex_scenarios:
      'Personalisierung der Webseite mit komplexen Szenarien',
    full_customization_of_communications_with_clients:
      'Vollständige Anpassung der Kunden-Kommunikation'
  },
  stripo_template_categories: {
    features: {
      title: '',
      amp: '',
      accordion_menu: '',
      css_animations: '',
      carousel: '',
      countdown_timer: '',
      image_rollover: '',
      video: '',
      gamification: ''
    },
    industries: {
      title: '',
      other: '',
      electronics: '',
      clothes: '',
      children_products: '',
      jewelry: '',
      art: '',
      books: '',
      auto_moto: '',
      construction: '',
      animals: '',
      products: '',
      ho_re_ca: '',
      tourism: '',
      transport: '',
      beauty: '',
      consulting: '',
      lawyers: '',
      software: '',
      real_estate: '',
      government: '',
      beverages: '',
      education: '',
      finance: '',
      gadgets: '',
      food: '',
      gifts_flowers_handmade: '',
      hotels: '',
      photography: '',
      publications_blogging: '',
      sports: '',
      webinars: '',
      no_name: ''
    },
    seasons: {
      title: '',
      world_tourism_day: '',
      summer_time: '',
      cyber_monday: '',
      halloween: '',
      labor_day: '',
      back_to_school: '',
      independence_day: '',
      fathers_day: '',
      memorial_day: '',
      mothers_day: '',
      easter: '',
      st_patricks_day: '',
      st_valentines_day: '',
      christmas: '',
      thanksgiving: '',
      black_friday: '',
      new_year: '',
      super_bowl: '',
      womens_day: '',
      birthday: '',
      global_shopping_festival: '',
      hanukkah: '',
      spring: '',
      wedding_invitation: ''
    },
    types: {
      title: '',
      abandoned_cart: '',
      alerts_and_notifications: '',
      apology: '',
      cold_emails: '',
      confirmation: '',
      discount: '',
      email_digest: '',
      event_reminder: '',
      events: '',
      follow_up: '',
      holidays: '',
      interactive: '',
      internal: '',
      invitation: '',
      new_collection: '',
      order: '',
      password_reset: '',
      post_purchase: '',
      product_update: '',
      promo: '',
      retention_and_reactivation: '',
      sales: '',
      smart_elements: '',
      survey_and_feedback: '',
      thank_you: '',
      welcome: ''
    }
  },
  web_push: {
    title_label: 'Titel',
    title_set_in_mailing: 'Der Titel wird beim Erstellen des Mailings festgelegt',
    body_required: 'Der Benachrichtigungstext darf nicht leer sein',
    body_label: 'Text',
    test_send: 'Test-Push senden',
    test_sending: 'Wird gesendet...',
    test_send_hint: 'Der Test-Push kommt in diesen Browser. Der Browser fragt zuerst nach der Berechtigung für Benachrichtigungen.',
    test_send_success: 'Test-Push gesendet. Prüfen Sie die Browser-Benachrichtigungen.',
    test_send_error: 'Test-Push konnte nicht gesendet werden. Prüfen Sie den Service Worker und die Benachrichtigungsberechtigung.',
    test_title_prompt: 'Geben Sie einen Titel für die Testbenachrichtigung ein',
    test_title_required: 'Geben Sie einen Titel ein',
    test_permission_denied: 'Benachrichtigungen für das Kontrollpanel sind blockiert. Erlauben Sie sie in den Website-Einstellungen in der Adressleiste.',
    test_render_error: 'Variablen in Titel oder Text konnten nicht eingesetzt werden',
    test_send_failed: 'Test-Push konnte nicht gesendet werden',
    test_no_permission: 'Keine Berechtigung, einen Test-Web-Push zu senden'
  }
}



// WEBPACK FOOTER //
// ./src/languages/deu.js